(function () {
  function setExpanded(button, expanded) {
    const group = button.closest('.mega-menu__group');
    if (!group) return;

    group.querySelectorAll('.mega-menu__child--extra').forEach((item) => {
      item.hidden = !expanded;
    });

    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded
      ? button.dataset.expandedLabel
      : button.dataset.collapsedLabel;
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-mega-menu-expand]');
    if (!button) return;

    setExpanded(button, button.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('toggle', (event) => {
    if (!event.target.matches('.mega-menu') || event.target.open) return;
    event.target.querySelectorAll('[data-mega-menu-expand]').forEach((button) => {
      setExpanded(button, false);
    });
  }, true);
})();
